<template>
  <v-autocomplete
    v-model="selected"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    clearable
    :label="label"
    return-object
    hide-details
    hide-selected
    browser-autocomplete="nope"
    no-filter
    no-data-text="Данные не выбраны"
    outline
    height="40"
    clear-icon="close"
    :menu-props="menuPropsClose"
    prepend-inner-icon="folder_open"
    :class="{ 'red lighten-4': selected && selected.isRemoved }"
    @change="handleItemChange"
    @click:clear="clear"
    @click="closeMenuPropsOnClick(false)"
  >
    <template v-slot:append>
      <v-icon
        :title="'Редактировать'"
        :disabled="disabledEditBtn"
        @click="createNew"
      >
        edit
      </v-icon>
    </template>
  </v-autocomplete>
</template>
<script>
import CloseDropdownList from "../../../mixins/close-dropdown-list.js";
import { NestedEditorsEventBus } from "../../../components/nested-editors/nested-editors-event-bus.js";
import * as referenceApi from "../../../backend/referenceApi.js";

export default {
  mixins: [CloseDropdownList],
  props: [
    "value",
    "label",
    "resource",
    "componentName",
    "disabledEditBtn",
    "storeResource",
    "carrierId",
  ],
  data() {
    return {
      selected: null,
      search: null,
      items: [],
      loading: false,
    };
  },
  computed: {
    editableRouteInfoItem() {
      return this.$store.getters[`${this.storeResource}/editableRouteInfoItem`];
    },
  },
  watch: {
    value: {
      handler() {
        if (!this.value) {
          this.selected = null;
          this.search = null;
          this.items = [];
          return;
        }
        if (
          this.selected &&
          this.value.id === this.selected.value &&
          this.value.title === this.search
        ) {
          return;
        }
        const selectedItem = this.items.find(i => i.value === this.value.id);
        if (selectedItem) {
          this.selected = selectedItem;
          this.search = selectedItem.text;
        } else {
          this.setSelectedElement(this.value);
        }
      },
      deep: true,
    },
    search() {
      if (!this.search) {
        this.selected = null;
        this.fetchAll();
        return;
      }

      if (this.loading) {
        return;
      }

      if (this.selected && this.selected.text === this.search) {
        return;
      }

      this.loading = true;
      setTimeout(() => {
        if (!this.search) {
          this.selected = null;
          this.items = [];
          this.loading = false;
          return;
        }

        const filter = new Object();
        filter.searchTerm = this.search;
        this.searchReference(filter);
        this.loading = false;
      }, 500);
    },
    editableRouteInfoItem: {
      handler() {
        if (!this.value) {
          this.selected = null;
        } else {
          this.setSelectedElement(this.value);
        }
      },
      deep: true,
    },
  },
  created() {
    if (this.value) {
      this.setSelectedElement(this.value);
    }
    NestedEditorsEventBus.$on("create-" + this._uid, createdId => {
      this.getReference(createdId);
    });
  },
  mounted() {
    this.$watch(
      () => {
        return this.$children[0].$data.isMenuActive;
      },
      newVal => {
        if (newVal) {
          this.fetchAll();
        } else {
          this.clear();
        }
      },
    );
  },
  methods: {
    handleItemChange() {
      this.$emit(
        "input",
        this.selected
          ? { id: this.selected.value, title: this.selected.text }
          : null,
      );
    },
    async fetchAll() {
      const filter = {
        carrierId: this.carrierId,
      };
      this.items = await referenceApi.getReferencies(this.resource, filter);
      if (this.selected) {
        const selectedItem = this.items.find(
          i => i.value === this.selected.value,
        );
        if (!selectedItem) {
          this.items.push({
            value: this.selected.value,
            text: this.selected.text,
          });
        }
      }
      this.loading = false;
    },
    clear() {
      this.items = [];
      if (this.selected) {
        this.items.push(this.selected);
      }
    },
    createNew() {
      this.closeMenuPropsOnClick(true);
      this.$emit("click");
      NestedEditorsEventBus.$emit("open", {
        title: this.label,
        uid: this._uid,
        component: this.componentName,
        params: this.selected,
        id: this.selected.value.toString(),
      });
    },
    setSelectedElement(value) {
      const newItem = {
        text: value.title,
        value: value.id,
        isRemoved: value.isRemoved,
      };
      this.selected = newItem;
      const item = this.items.find(i => i.value === newItem.value);
      if (item) {
        this.items.forEach(i => {
          if (i.value === newItem.value) {
            i.text = newItem.text;
          }
        });
      } else {
        this.items.push(this.selected);
      }
    },
    async getReference(id) {
      const res = await referenceApi.getReference(this.resource, id);
      await this.setSelectedElement(res);
      this.handleItemChange();
    },
    async searchReference(filter) {
      filter.carriedId = this.carrierId;
      this.items = await referenceApi.getReferencies(this.resource, filter);
    },
  },
};
</script>
